/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function() {
  // Използваме observer, за да следим за промени в sidebar-cart
  var euroRate = 1.95583;
  function addEuroToDiscountAndTotal() {
    var sidebar = document.getElementById('sidebar-cart');
    if (!sidebar) return;
    // --- ОТСТЪПКА ---
    var discountRows = sidebar.querySelectorAll('.sc_code-info');
    discountRows.forEach(function(row) {
      var valueDiv = row.querySelector('div:last-child');
      if (!valueDiv) return;
      // Търсим .money вътре
      var moneyEl = valueDiv.querySelector('.money');
      if (!moneyEl) return;
      // Проверяваме дали вече има евро
      if (valueDiv.innerHTML.includes('€')) return;
      var match = moneyEl.textContent.match(/([\d\.,]+)\s*лв/);
      if (match) {
        var bgn = parseFloat(match[1].replace(',', '.'));
        var eur = (bgn / euroRate).toFixed(2);
        valueDiv.innerHTML += ' <span style="color:#888; font-size:0.95em;">(' + eur + ' €)</span>';
      }
    });
    // --- ТОТАЛ ---
    var totalRows = sidebar.querySelectorAll('.sc_simple-info__row');
    totalRows.forEach(function(row) {
      var labelDiv = row.querySelector('div:first-child strong');
      if (!labelDiv) return;
      if (labelDiv.textContent.trim() !== 'Тотал:') return;
      var valueDiv = row.querySelector('div:last-child');
      if (!valueDiv) return;
      var moneyEl = valueDiv.querySelector('.money');
      if (!moneyEl) return;
      if (moneyEl.parentElement.innerHTML.includes('€')) return;
      var match = moneyEl.textContent.match(/([\d\.,]+)\s*лв/);
      if (match) {
        var bgn = parseFloat(match[1].replace(',', '.'));
        var eur = (bgn / euroRate).toFixed(2);
        moneyEl.insertAdjacentHTML('afterend', ' <span style="color:#888; font-size:0.95em;">(' + eur + ' €)</span>');
      }
    });
  }
  // Observer за sidebar-cart
  var observer = new MutationObserver(function() {
    addEuroToDiscountAndTotal();
  });
  document.addEventListener('DOMContentLoaded', function() {
    var sidebar = document.getElementById('sidebar-cart');
    if (sidebar) {
      observer.observe(sidebar, { childList: true, subtree: true });
      addEuroToDiscountAndTotal();
    }
  });
  // За всеки случай - периодично обновяване
  setInterval(addEuroToDiscountAndTotal, 2000);
})();